import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { Observable, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoggerService } from 'src/app/services/logger.service';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core'


@Component({
  selector: 'app-tax-tables',
  templateUrl: './tax-tables.component.html',
  styleUrls: ['./tax-tables.component.css']
})
export class TaxTablesComponent implements OnInit {
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  clientList: Array<any> = [];
  dtOptions: DataTables.Settings = {};
  restLoader: boolean = true;
  dtTrigger: Subject<any> = new Subject<any>();
  allProvinces:any=[];
  allProvincesDuplicate:any=[];
  selectedCatalog:any=[];
  displayCatalog:any=[];
  taxData:any=[];
  provinces:any=[];
  allProvinces1 = [];
  provinceKeys = [];
  taxData1=[];
  taxesData=[]
  public lang: any = {};
  languageData$: any;
  selectedLanguage: string;
  filterPlanslist: Array<any> = [];
  selectedPlan: string = '';
  selectedAction: string = '';
  actions: string[] = [
    'Generate PDF',
    'Edit Tax Table',
    'Create  New Tax Table',
    'Display Tax Table'
  ];

  plans: string[] = [
    'All-in-Bronze',
    'All-in-Gold',
    'All-in-Silver',

  ];
  multiSelectProviance: any=[];
  multiSelectProviance1:any=[];
  multiSelectProviancenames1: any = [];
  multiSelectProviancenames: any = [];
  dropdownSettings = {};
  configprovincereslist1: any;
  configprovincereslist2:any;
  defaultCountry: any = "Canada";
  countryList: any;
  selectedProvinceList: any = [];
  multiProvinceSelectedValues: any;
  fullTaxData: any=[];
  

  multiSelectProvianceItemSelect(event: any) {
    this.multiSelectProviancenames.push(event);
    this.logger.log("event: " + JSON.stringify(event));
    this.multiSelectProviance.push(Number(event.id));
    this.logger.log("this.multiSelectProvianc12e: " + this.multiSelectProviance);
    this.logger.log("this.multiSelectProviance: " + JSON.stringify(this.multiSelectProviance));
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  multiSelectProvianceItemSelect1(event:any){
    this.multiSelectProviancenames.push(event);
    this.logger.log("event: " + JSON.stringify(event));
    this.multiSelectProviance.push(Number(event.id));
    this.logger.log("this.multiSelectProvianc12e: " + this.multiSelectProviance);
    this.logger.log("this.multiSelectProviance: " + JSON.stringify(this.multiSelectProviance));
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }
  multiSelectProvianceSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    event.forEach((proviance: any) => {
      this.multiSelectProviance.push(proviance.id);
      this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });

    });
    this.logger.log(this.multiSelectProviance);
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  multiSelectProvianceSelectAll1(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    event.forEach((proviance: any) => {
      this.multiSelectProviance.push(proviance.id);
      this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });

    });
    this.logger.log(this.multiSelectProviance);
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }


  multiSelectProvianceItemDeSelect(event: any) {
    this.logger.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviancenames.splice(indexOf, 1);
    this.multiSelectProviance.splice(indexOf, 1);
    this.logger.log(this.multiSelectProviance);

    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);

  }

  multiSelectProvianceItemDeSelect1(event: any) {
    this.logger.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviancenames.splice(indexOf, 1);
    this.multiSelectProviance.splice(indexOf, 1);
    this.logger.log(this.multiSelectProviance);

    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);

  }

  multiSelectProvianceItemDeSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }
  multiSelectProvianceItemDeSelectAll1(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
    this.getprovincelistselection2(this.defaultCountry, this.multiSelectProviance);
  }
  async getprovincelistselection1(event: any, selectedList: any) {
    this.logger.log("getprovincelistselection: " + event);
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
    let uniqueSet = new Set(selectedList);
    selectedList = Array.from(uniqueSet);
    setTimeout(() => {
      if (this.countryList) {
        this.countryList.forEach((element: any) => {
          if (element.name == event) {
            this.configprovincereslist1 = element.countryStates;
            const stateIdNamePairs: { [key: string]: string } = {};
            this.selectedProvinceList = [];


            this.configprovincereslist1.forEach((state: any) => {
              if (selectedList.includes(state.id)) {
                this.selectedProvinceList.push(state);
              }
              stateIdNamePairs[state.id] = state.shortName;
            });

            this.configprovincereslist1 = [...this.configprovincereslist1].sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );

            const selectedNames = Array.from(
              new Set(
                selectedList
                  .map(id => stateIdNamePairs[id])
                  .filter(name => name !== undefined)
              )
            );

            if (selectedNames.length > 0) {
              this.multiProvinceSelectedValues = selectedNames.join(', ');
            }

            this.logger.log("Selected Names: ", this.multiProvinceSelectedValues);
          }
        });
      }
    }, 500);
  }
  async getprovincelistselection2(event: any, selectedList: any) {
    this.logger.log("getprovincelistselection: " + event);
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
    let uniqueSet = new Set(selectedList);
    selectedList = Array.from(uniqueSet);
    setTimeout(() => {
      if (this.countryList) {
        this.countryList.forEach((element: any) => {
          if (element.name == event) {
            this.configprovincereslist2 = element.countryStates;
            const stateIdNamePairs: { [key: string]: string } = {};
            this.selectedProvinceList = [];


            this.configprovincereslist2.forEach((state: any) => {
              if (selectedList.includes(state.id)) {
                this.selectedProvinceList.push(state);
              }
              stateIdNamePairs[state.id] = state.shortName;
            });

            this.configprovincereslist2 = [...this.configprovincereslist2].sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );

            const selectedNames = Array.from(
              new Set(
                selectedList
                  .map(id => stateIdNamePairs[id])
                  .filter(name => name !== undefined)
              )
            );

            if (selectedNames.length > 0) {
              this.multiProvinceSelectedValues = selectedNames.join(', ');
            }

            this.logger.log("Selected Names: ", this.multiProvinceSelectedValues);
          }
        });
      }
    }, 500);
  }

  selectedProvinceData: any = null;

  onProvinceChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.selectedProvinceData = this.taxData[selectedValue];
  }

  datarecords: string[] = [
    'Health & Dental',
    'Wellness',
    'Travel',
    'Private Health',
    'TeleMedicine',
    'Life & CI',
    'Bundle 1',
    'Bundle'

  ];
  tableData = [
    { value1: 'V44', date1: '01/01/25', date2: '31/05/25', selectedNote: 'Option 1' }
  ];

  selectedRegion: string = '';
  
  newCatalog = {
    name: '',
    tax: '',
    version: '',
    startDate: '',
    endDate: ''
  };

  // Catalogs data array
  catalogs = [];
  selectedCountry:any;
 
  

  onActionSelect() {
    if (this.selectedAction === 'Display Tax Table') {
      const filteredSelectedProvinces = this.allProvincesDuplicate.filter(prov =>
        this.multiSelectProviance.includes(prov.id)
      );
  
      this.provinceKeys = filteredSelectedProvinces.map(prov => prov.shortName);
  
      this.allProvinces1 = this.taxData1.map(tax => {
        const taxData = JSON.parse(tax.taxData ?? '{}');
  
        const row = this.provinceKeys.map(shortName => {
          const provinceData = Object.values(taxData).find((province: any) => (province as any).shortName === shortName) as any;
  
          return {
            shortName: shortName,
            taxRate: provinceData?.taxRate ?? ''
          };
        });
  
        return row;
      });
  
      console.log('Selected Province Keys:', this.provinceKeys);
      console.log('Tax Data With ShortName + TaxRate:', this.allProvinces1);
    } else {
      console.log('show tax table tax rates');
    }
  }
  
  
  
  

  // This function is called when the region changes
  onRegionChange(value) {
    console.log("Selected Region: ", value);
    this.provinces = this.allProvinces?.filter((province:any)=>province.countryId==value)
    console.log('this.provinces',this.provinces)
    this.configprovincereslist1=this.allProvinces?.filter((province:any)=>province.countryId==value)
     console.log('this.provinces',this.provinces)
     this.cdRef.detectChanges();
  }
  
  openModelAddMumber() {
    console.log('ok');
    this.router.navigate(['/addTax']);
  }

  
  constructor(private store: Store<{ languageData: [] }>, private http: HttpClient,private logger: LoggerService,private  router: Router,private cdRef: ChangeDetectorRef) {
    this.languageData$ = store.select(selectLanguageData);
  }
  submitNewCatalog() {
    if (
      this.newCatalog.name &&
      this.newCatalog.tax &&
      this.newCatalog.version &&
      this.newCatalog.startDate &&
      this.newCatalog.endDate
    ) {
      this.catalogs.push({ ...this.newCatalog });
      alert('Catalog created successfully!');
      // this.resetCatalogForm(); // Optional: reset form after submission
    } else {
      alert('Please fill in all catalog details.');
    }
  }
  resetCatalogForm() {
    this.newCatalog = {
      name: '',
      tax: '',
      version: '',
      startDate: '',
      endDate: ''
    };
  }


  
  ngOnInit(): void {
    this.getLanguageTokens();
    this.getTaxDetails()
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      destroy: true,
      columnDefs: [],
      search: false
    };

    this.dropdownSettings = {
      singleSelection: false,
      closeDropDownOnSelection: true,
      idField: 'id',
      // textField: 'name',
      textField: 'shortName',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    // this.dtTrigger.next(null)
  }
  public getLanguageTokens() {
    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
          this.dtTrigger.next(null)
        }, 0)
      }
    })
  }

  public getTaxDetails() {
    var endPoint = '/api/ap/taxTable';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      // .get(environment.apiUrl + endPoint, {
      .get('http://[::1]:3002' + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }
      )
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            console.log(response)
            this.allProvinces = response.data.states
            this.allProvincesDuplicate = response.data.states
            this.configprovincereslist1 = this.allProvinces
            let selectedList = []
            const stateIdNamePairs: { [key: string]: string } = {};
            this.selectedProvinceList = [];

            this.configprovincereslist1.forEach((state: any) => {
              if (selectedList.includes(state.id)) {
                this.selectedProvinceList.push(state);
              }
              stateIdNamePairs[state.id] = state.shortName;
            });

            this.configprovincereslist1 = [...this.configprovincereslist1].sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );
            this.configprovincereslist2 = this.configprovincereslist1.filter(obj=>obj.countryId==2)
            this.configprovincereslist1 = this.configprovincereslist1.filter(obj=>obj.countryId==1)
            console.log('configprovincereslist1',this.configprovincereslist1)
            
            this.allProvinces1 = []
            this.taxData1 = response.data.tax
            this.taxData1.map(tax=>{
              let taxData = JSON.parse(tax.taxData??'[]') 
              this.provinceKeys = Object.keys(taxData)
              let obj=[]
              for(let i=0;i<this.provinceKeys.length;i++){
                  obj.push(taxData?.[this.provinceKeys[i]]?.taxRate)
              }
              console.log(obj)
              this.allProvinces1.push(obj)
          })
           
          console.log('this.allProvinces1',this.allProvinces1)
          }else{
            console.log(response);
          }
        })

      }
}

